export default "assets/images/icons/address-a81a99d6.svg";